import $axios from '@/api/apiConnection'
import parseCatch from '@/helpers/handleErrors'

export const reportTriggerApi = {
    async createReportTrigger(data) {
        try {
            const response = await $axios.post('/Report/TriggerUpsert/', data)
            return response
        } catch (e) {
            parseCatch(e, true, 'Report Trigger Upsert')
        }
    },
    async reportTriggerChangeStatus(payload) {
        try {
            const { Data } = await $axios.post('/Report/TriggerChangeStatus/', payload)
            return Data
        } catch (e) {
            parseCatch(e, true, 'Report trigger change status​')
        }
    }
}